module.exports = __webpack_public_path__ + "static/media/house-signal.25cf3b7d.svg";